var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4,13.3c-0.2,0-0.3,0-0.5,0c-1.3,0-2.6,0-3.9,0c-1.1,0-1.7-0.7-1.6-1.7c0-0.3,0.2-0.6,0.4-0.9C4.9,7.3,7.8,4,10.8,0.6 c0.7-0.8,1.7-0.8,2.5,0c2.9,3.4,5.9,6.7,8.8,10.1c0.4,0.5,0.6,1.1,0.3,1.7c-0.3,0.6-0.8,0.9-1.5,0.9c-1.3,0-2.6,0-3.9,0 c-0.1,0-0.3,0-0.4,0c0,0.2,0,0.3,0,0.5c0,2.8,0,5.6,0,8.5c0,1.1-0.6,1.7-1.7,1.7c-1.9,0-3.9,0-5.8,0c-1,0-1.7-0.6-1.7-1.7 c0-2.8,0-5.7,0-8.5C7.4,13.7,7.4,13.5,7.4,13.3z M3,11.8c0.2,0,0.3,0,0.4,0c1.5,0,3,0,4.5,0c0.8,0,1,0.4,1,1c0,3,0,6.1,0,9.1 c0,0.1,0,0.3,0,0.5c2,0,4,0,6.1,0c0-0.2,0-0.3,0-0.5c0-3.1,0-6.1,0-9.2c0-0.7,0.3-0.9,0.9-0.9c1.5,0,2.9,0,4.4,0c0.2,0,0.3,0,0.6,0 c-3-3.5-6-6.8-9-10.3C9,5,6,8.4,3,11.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.22415862793a67e6733086e1fd5a34c3.svg";
export { ForwardRef as ReactComponent };